import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'liberro-pagination',
  standalone: false,
  templateUrl: './liberro-pagination.component.html',
  styleUrl: './liberro-pagination.component.less'
})
export class LiberroPaginationComponent {
  @Input() public pageIndex = 1;
  @Input() public pageSize = 10;
  @Input() public total = 0;
  @Input() public pageSizeOptions: number[] = [10, 20, 50];
  @Input() public showSizeChanger = false;
  @Input() public showQuickJumper = false;
  @Input() public simple = false;
  @Input() public disabled = false;
  @Input() public simpleMode = false;
  @Input() public size: 'small' | 'default' = 'default';

  @Output() public pageIndexChange = new EventEmitter<number>();
  @Output() public pageSizeChange = new EventEmitter<number>();

  public onPageIndexChange(index: number): void {
    this.pageIndex = index;
    this.pageIndexChange.emit(index);
  }

  public onPageSizeChange(size: number): void {
    this.pageSize = size;
    this.pageSizeChange.emit(size);
  }

}
